import {useState, useCallback} from "react";
import {deleteHubZip} from "../services/hub-users.service";

const useDeleteHubZip = (onSuccess) => {

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const remove = useCallback(
        async (id) => {
            setLoading(true);
            setErrorMessage(null);
            try {
                const result = await deleteHubZip(id);
                onSuccess();
            }
            catch(error){
                setErrorMessage(error);
            }
            finally {
                setLoading(false);
            }
        },
        [onSuccess],
    );


    return {
        remove,
        loading,
        errorMessage,
    }
};

export default useDeleteHubZip;